/**
 * Secure token management utility
 * Handles API tokens securely and prevents them from being exposed in logs
 */

export class SecureTokenManager {
  private static instance: SecureTokenManager;

  private constructor() {}

  public static getInstance(): SecureTokenManager {
    if (!SecureTokenManager.instance) {
      SecureTokenManager.instance = new SecureTokenManager();
    }
    return SecureTokenManager.instance;
  }

  public getAdminSessionToken(): string {
    const token = sessionStorage.getItem('token');

    if (!token) {
      throw new Error('Admin session is missing. Please sign in again.');
    }

    return token;
  }

  public clearAllTokens(): void {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('loginTimestamp');
  }

  public setLoginTimestamp(): void {
    sessionStorage.setItem('loginTimestamp', Date.now().toString());
  }

  public checkSessionValid(): boolean {
    const timestamp = sessionStorage.getItem('loginTimestamp');
    if (!timestamp) return false;

    const loginTime = parseInt(timestamp, 10);
    const currentTime = Date.now();
    const oneDayInMs = 24 * 60 * 60 * 1000;

    return (currentTime - loginTime) < oneDayInMs;
  }
}

// Export singleton instance
export const secureTokenManager = SecureTokenManager.getInstance();
